import jsonp from 'jsonp'
import { getCallback } from '@/utils/utils'

const baseURL = 'https://directory.aws.stthomas.edu/api.htm'

export default {
  getDepartmentsByName (query) {
    return new Promise((resolve, reject) => {
      const callback = getCallback()

      jsonp(`${baseURL}?callback=${callback}&requestType=searchDepartmentByName&query=${query}`, { name: callback }, (err, data) => {
        if (err) {
          console.error(err.message)
          reject(err.message)
        } else {
          resolve(data)
        }
      })
    })
  },

  getDepartmentsByCode (code) {
    return new Promise((resolve, reject) => {
      const callback = getCallback()

      jsonp(`${baseURL}?callback=${callback}&requestType=getDepartmentsByBuildingCode&buildingCode=${code}`, { name: callback }, (err, data) => {
        if (err) {
          console.error(err.message)
          reject(err.message)
        } else {
          resolve(data)
        }
      })
    })
  },

  getDepartmentsByNetId (id) {
    return new Promise((resolve, reject) => {
      const callback = getCallback()

      jsonp(`${baseURL}?callback=${callback}&netId=${id}`, { name: callback }, (err, data) => {
        if (err) {
          console.error(err.message)
          reject(err.message)
        } else {
          resolve(data)
        }
      })
    })
  },

  getDepartmentsByUstId (id) {
    return new Promise((resolve, reject) => {
      const callback = getCallback()

      jsonp(`${baseURL}?callback=${callback}&ustId=${id}`, { name: callback }, (err, data) => {
        if (err) {
          console.error(err.message)
          reject(err.message)
        } else {
          resolve(data)
        }
      })
    })
  },

  getAdministrativeDepartments () {
    return new Promise((resolve, reject) => {
      const callback = getCallback()

      jsonp(`${baseURL}?callback=${callback}&requestType=getAdministrativeDepartments`, { name: callback }, (err, data) => {
        if (err) {
          console.error(err.message)
          reject(err.message)
        } else {
          resolve(data)
        }
      })
    })
  },

  getCenterDepartments () {
    return new Promise((resolve, reject) => {
      const callback = getCallback()

      jsonp(`${baseURL}?callback=${callback}&requestType=getCenterDepartments`, { name: callback }, (err, data) => {
        if (err) {
          console.error(err.message)
          reject(err.message)
        } else {
          resolve(data)
        }
      })
    })
  },

  getDepartmentsByOrgCode (code) {
    return new Promise((resolve, reject) => {
      const callback = getCallback()

      jsonp(`${baseURL}?callback=${callback}&requestType=getDepartmentByOrgnCode&orgnCode=${code}`, { name: callback }, (err, data) => {
        if (err) {
          console.error(err.message)
          reject(err.message)
        } else {
          resolve(data)
        }
      })
    })
  },

  getClubs () {
    return new Promise((resolve, reject) => {
      const callback = getCallback()

      jsonp(`${baseURL}?callback=${callback}&requestType=getClubs`, { name: callback }, (err, data) => {
        if (err) {
          console.error(err.message)
          reject(err.message)
        } else {
          resolve(data)
        }
      })
    })
  }
}
